import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const NewPost = ({ content, setContent }) => {
  return (
    <div>
      <ReactQuill value={content} onChange={setContent} />
    </div>
  );
};

export default NewPost;
